import { Icon } from "@mui/material";
import "./user-input.css";
const UserInput = ({
  value = "",
  onChange = () => {},
  label = "Label",
  placeholder = "",
  onAdd = false,
  style = {},
  icon = null
}) => {
  return (
    <div className="user-input-container" style={style}>
      <span className="user-input-label">
        {typeof icon === "string" ? <Icon>{icon}</Icon> : icon ? icon : null}
        {label.toUpperCase()}:
      </span>
      <input
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className="user-input"
        type="text"
      />
      {onAdd ? (
        <button
          onClick={() => {
            onAdd({ value, onChange });
          }}
          className={`e1-btn small ${value ? "" : "disabled"}`}
        >
          <Icon sx={{ color: "#fff !important" }}>add</Icon>
        </button>
      ) : null}
    </div>
  );
};

export default UserInput;
